module.exports = __webpack_public_path__ + "static/media/nodeFirstRoute.362b8969.png";